export const all = new Map([
  ['1', { com: () => import('./on-job-en.vue'), lang: 'en', name: 'staff_name_en', key: '1853' }],
  ['2', { com: () => import('./on-job-th.vue'), lang: 'th', name: 'staff_name_th', key: '1851' }],
  ['3', { com: () => import('./wage-en.vue'), lang: 'en', name: 'staff_name_en', key: '1857' }],
  ['4', { com: () => import('./wage-th.vue'), lang: 'th', name: 'staff_name_th', key: '1854' }],
  ['5', { com: () => import('./obtain-en.vue'), lang: 'en', name: 'staff_name_en', key: '1862' }],
  ['6', { com: () => import('./obtain-th.vue'), lang: 'th', name: 'staff_name_th', key: '1859' }]
])
export default {
  th: new Map([
    ['1', { com: () => import('./on-job-th.vue'), lang: 'th', name: 'staff_name_th', key: '1851' }],
    ['2', { com: () => import('./wage-th.vue'), lang: 'th', name: 'staff_name_th', key: '1854' }],
    ['3', { com: () => import('./obtain-th.vue'), lang: 'th', name: 'staff_name_th', key: '1859' }]
  ]),
  en: new Map([
    ['1', { com: () => import('./on-job-en.vue'), lang: 'en', name: 'staff_name_en', key: '1853' }],
    ['2', { com: () => import('./wage-en.vue'), lang: 'en', name: 'staff_name_en', key: '1857' }],
    ['3', { com: () => import('./obtain-en.vue'), lang: 'en', name: 'staff_name_en', key: '1862' }]
  ])
}
